import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "antd";
import LabeledInput from "components/Form/LabeledInput";
import LabeledSelectInput from "components/Form/LabeledSelectInput";
import { IBank } from "models/bank";
import { IDriverWalletInput } from "models/driverWallet";
import { useForm } from "react-hook-form";
import createWalletValidator from "validators/createWallet.validator";

interface IProps {
  banks: { loading: boolean; data: IBank[] };
  onWalletInfoSubmit: (input: IDriverWalletInput) => void;
  stepper: number;
  handleBackStepper: () => void;
  loading: boolean;
}

export default function WalletInfoStepper({
  banks,
  onWalletInfoSubmit,
  loading,
  handleBackStepper,
  stepper,
}: IProps) {
  const { control, handleSubmit } = useForm<IDriverWalletInput>({
    resolver: yupResolver(createWalletValidator),
  });

  return (
    <form
      onSubmit={handleSubmit(onWalletInfoSubmit)}
      className={`w-full ${stepper === 3 ? "flex" : "hidden"} flex-wrap`}
    >
      <div className="w-full px-4 pt-5 md:w-1/3">
        <LabeledSelectInput
          label="Bank"
          control={control}
          loading={banks.loading}
          name="bank"
          placeholder="Select Bank"
          options={banks.data.map((value) => ({
            value: value.name,
            label: value.name,
          }))}
        />
      </div>
      <div className="w-full px-4 pt-5 md:w-1/3">
        <LabeledInput
          label="Account Number"
          type="text"
          control={control}
          name="account"
          placeholder="Account Number"
        />
      </div>
      <div className="w-full px-4 pt-5 md:w-1/3">
        <LabeledInput
          label="Wallet balance"
          type="number"
          control={control}
          name="balance"
          placeholder="Wallet balance"
        />
      </div>
      <div className="w-full flex mt-8 justify-between">
        <Button
          onClick={handleBackStepper}
          disabled={loading}
          type="primary"
          className="py-2 px-8 rounded-md float-right h-auto font-medium w-fit shadow-none"
        >
          Back
        </Button>
        <Button
          htmlType="submit"
          type="primary"
          disabled={loading}
          loading={loading}
          className="py-2 px-8 rounded-md float-right h-auto font-medium w-fit shadow-none"
        >
          Next
        </Button>
      </div>
    </form>
  );
}
